import ProductOptions from "components/admin/views/management/product/ProductOptions";

export const all_routes = {

    /* ----------------------------------------------------
        ADMIN ROUTES
    ---------------------------------------------------- */


    // Content
    homeBannerSlider: '/admin/content/home-banner-slide',
    faqadmin: '/admin/content/faq',
    homeItemsAdmin: '/admin/content/home-page',
    aboutArtectum: '/admin/content/about-artectum',
    complaintAdmin: '/admin/content/complaint',

    blogAdmin: '/admin/content/blog',
    blogCommentsAdmin: '/admin/content/blog/comments',
    blogSlideSectionAdmin: '/admin/content/blog/slide-section',
    // Content

    // Management
    informationAdmin: '/admin/management/information',
    clientsAdmin: '/admin/management/clients',
    projectsAdmin: '/admin/management/projects',
    projectDetailsAdmin: '/admin/management/projects/projects-detail',

    productAdmin: '/admin/management/product',
    productOptionsAdmin: '/admin/management/product/product-options',
    productSpecificationAdmin: '/admin/management/product/product-specification',
    productHelp: '/admin/management/product/product-help',
    categoriesAdmin: '/admin/management/product/categories',

    filtersAdmin: '/admin/management/filters',
    productFiltersAdmin: '/admin/management/filters/product-filters',
    projectFiltersAdmin: '/admin/management/filters/project-filters',

    contactFormAdmin: '/admin/reports/contact',
    // Management

    usersRegister: '/admin/content/user-register',
    headquarters: '/admin/administration/headquarters',
    information: '/admin/administration/information',
    paymentDays: '/admin/administration/payment-days',
    salesHistory: '/admin/administration/sales-history',

    /* ----------------------------------------------------
        ADMIN ROUTES
    ---------------------------------------------------- */

    /* ----------------------------------------------------
        USER ROUTES
    ---------------------------------------------------- */

    home: '/',


    blogDetails: '/blog/blog-detail',

    product: '/product/product-list',
    productDetails: '/product/product-details',
    productCategories: '/product/product-categories',

    portfolio: '/portfolio/portfolio-list',
    projectDetails: '/portfolio/project-details',

    about: '/about',
    aboutProducts: '/about-products',

    faq: '/faq',
    contact: '/contact',

    /* ----------------------------------------------------
        USER ROUTES
    ---------------------------------------------------- */
};